import React from 'react'

const MenuOverlay: React.FC = () => {
  //   $(".settings-pane div, .settings-pane form").click(function (event) {
  //     event.stopPropagation();
  // });

  return (
    <div id="menu-overlay" className="hidden">
      <div className="container">
        <div className="row">
          <div className="settings-pane col-md-3">
            {/* @*<form>
          <h3>Upload GPX route</h3>
          <p>Upload your .gpx route file.</p>
                  <div className="imray-custom-file">
                      <input type="file" id="files" name="files">
                      <label className="imray-custom-file-label" for="files">Choose file</label>
                  </div>
                  </form>
                  <form>
                  <h3>Settings</h3>
                  <label><input type="checkbox" /> Show chart outlines</label>
                  <br />
                  <hr />*@ */}
            <div>
              <a
                className="btn btn-danger"
                asp-controller="Account"
                asp-action="Logout"
              >
                Logout
              </a>
            </div>
            {/* @*</form>*@ */}
          </div>
          <div className="settings-pane col-md-6">
            <div>
              <h3>My charts</h3>

              <ul id="my-chart-list"></ul>
            </div>
          </div>
          {/* @*<div className="settings-pane col-md-3">
                  <div>
                      <h3>My data</h3>
                      <ul>
                          <li>
                              <a href="#">Routes</a>
                          </li>
                          <li>
                              <a href="#">Tracks</a>
                          </li>
                      </ul>
                  </div>
              </div>*@ */}
        </div>
      </div>
    </div>
  )
}

export default MenuOverlay
